import { useState, useCallback } from 'react'
import { Button, kuiperClassNames } from '@opallabs/kuiper'
import { DotLoader } from '@opallabs/lapidary'
import { SnapshotObject } from '../types'
import './styles.scss'

type SnapshotPaneProps = {
  onDownloadClick?: (url: string | null) => void
  snapshot: SnapshotObject
  type: 'before' | 'after'
}

const SnapshotPane = ({
  onDownloadClick,
  snapshot,
  type,
}: SnapshotPaneProps) => {
  const [imageWidth, setImageWidth] = useState<number>()
  const [imageLoaded, setImageLoaded] = useState(false)

  const imageRef = useCallback(
    (node) => {
      if (node && imageLoaded && !imageWidth) {
        const width = node.getBoundingClientRect().width
        setImageWidth(width / 2)
      }
    },
    [imageLoaded, imageWidth]
  )

  if (!snapshot.url) return null

  return (
    <div className={kuiperClassNames(`${type}-snapshot snapshot`)}>
      <p className={kuiperClassNames('snapshot-title')}>{type} Edit</p>
      <span className={kuiperClassNames('user')}>
        Edited by {snapshot.user}
      </span>
      <span className={kuiperClassNames('date')}>
        {snapshot.date}
        <Button
          ariaLabel={`download ${type} snapshot`}
          onClick={() => onDownloadClick?.(snapshot.url)}
          icon="download"
          type="invisible"
          tooltip={{ themeClass: 'light', content: 'Download' }}
        />
      </span>
      <a
        style={{ width: imageWidth }}
        href={snapshot.url}
        rel="noopener noreferrer"
        target="_blank"
      >
        {imageLoaded ? (
          <img src={snapshot.url} alt="Snapshot of content" />
        ) : null}
      </a>
      {!imageLoaded && <DotLoader height={300} />}
      <img
        className={kuiperClassNames('reference-image')}
        ref={imageRef}
        onLoad={() => setImageLoaded(true)}
        src={snapshot.url}
        alt=""
      />
    </div>
  )
}

export default SnapshotPane
